export const SAVE_PERSONAL_INFO = 'SAVE_PERSONAL_INFO';
export const SAVE_SKILLS_AND_CERTIFICATES = 'SAVE_SKILLS_AND_CERTIFICATES';
export const GET_PUBLICATIONS = 'GET_PUBLICATIONS';
export const GET_PERSONAL_INFORMATION = 'GET_PERSONAL_INFORMATION';
export const GET_PROFILE = 'GET_PROFILE';
export const UPLOAD_PROFILE_PICTURE = 'UPLOAD_PROFILE_PICTURE';
export const GET_PROJECT_OVERVIEW = 'GET_PROJECT_OVERVIEW';
export const GET_ADMIN_DASHBOARD = 'GET_ADMIN_DASHBOARD';
export const ADD_ADMIN_DASHBOARD_PROJECT = 'ADD_ADMIN_DASHBOARD_PROJECT';
export const REMOVE_ADMIN_DASHBOARD_PROJECT = 'REMOVE_ADMIN_DASHBOARD_PROJECT';
export const GET_FILE = 'GET_FILE';
export const GET_ALL_SUPERVISOR = 'GET_ALL_SUPERVISOR';
export const ADD_SYSTEM_MESSAGE = 'ADD_SYSTEM_MESSAGE';
export const SET_PROFILE_IMAGE_PENDING = 'SET_PROFILE_IMAGE_PENDING';
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';

//#region archive
export const GET_ARCHIVED_PROJECTS = 'GET_ARCHIVED_PROJECTS';
export const GET_VISIBLE_ARCHIVED_PROJECTS = 'GET_VISIBLE_ARCHIVED_PROJECTS';
export const GET_ARCHIVED_PROJECT = 'GET_ARCHIVED_PROJECT';
export const REMOVE_ARCHIVED_PROJECT = 'REMOVE_ARCHIVED_PROJECT';
//#endregion archive
